import { render, staticRenderFns } from "./FavoriteWines.vue?vue&type=template&id=26671ab6&scoped=true&"
import script from "./FavoriteWines.vue?vue&type=script&lang=js&"
export * from "./FavoriteWines.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteWines.vue?vue&type=style&index=0&id=26671ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26671ab6",
  null
  
)

export default component.exports